import TeamsField from './TeamsField.component';

export default TeamsField;
